import { handlePrice, getStatusLabel } from '@/utils'

// 处方详情 基本信息
const BASE_LABEL = [
  {
    label: '姓名: ',
    prop: 'patientName',
    class: 'small'
  },
  {
    label: '性别: ',
    prop: 'patientGender',
    class: 'small',
    render: (text, record) => {
      const { patientGender } = record || {}
      return patientGender || patientGender === 0 ? ['女', '男', '未知'][patientGender] : '--'
    }
  },
  {
    label: '年龄: ',
    prop: 'patientAge',
    class: 'small'
  },
  {
    label: '医生: ',
    prop: 'doctorName',
    class: 'small'
  },
  {
    label: '互联网医院: ',
    prop: 'agencyId',
    class: 'big'
  }
]
// 辅助方药品信息 商品信息
const columnHealth = [
  { title: 'sku 编号', dataIndex: 'spuCode', key: 'spuCode' },
  { title: 'sku 名称', dataIndex: 'skuName', key: 'skuName' },
  {
    title: '数量（盒）',
    dataIndex: 'quantity',
    key: 'quantity'
  },
  {
    title: '销售价格（元）',
    dataIndex: 'healthPrice',
    key: 'healthPrice'
  }
]
// 获取处方标签
const getStatusImg = info => {
  const { status, expireStatus, invalid } = info
  return getStatusLabel({ status, expire: expireStatus, invalid })
}
// 处方状态 0：未购， 1：已全部购买， 2：待支付，3 已作废 4:已取消 5:删除 6:失效
// FIXME: 2：待支付=》已购买 2022/4/7（处方没有代购买状态）
// const statusImg = [
//   {
//     id: 0,
//     alt: '未购买',
//     src: require('@/assets/img/work-place/buy-notv1.png')
//   },
//   {
//     id: 1,
//     alt: '已购买',
//     src: require('@/assets/img/work-place/buy-already.png')
//   },
//   {
//     id: 2,
//     alt: '已下单未支付',
//     src: require('@/assets/img/work-place/buy-notPay.png')
//     // id: 2,
//     // alt: '待支付',
//     // src: require('@/assets/img/work-place/to-de-purchased.png')
//   },
//   {
//     //NOTE:部分购买也是已购买
//     id: 3,
//     alt: '已购买',
//     src: require('@/assets/img/work-place/buy-already.png')
//   },
//   { id: 4, alt: '已取消', src: require('@/assets/img/work-place/cancel.png') },
//   { id: 5, alt: '已删除', src: require('@/assets/img/work-place/delete.png') },
//   // 失效
//   { id: 6, alt: '已作废', src: require('@/assets/img/work-place/voidv1.png') },
//   { id: 7, alt: '已失效', src: require('@/assets/img/work-place/invalid-already.png') }
// ]
// 订单信息
const columnOrder = [
  {
    title: '订单号',
    dataIndex: 'orderSn',
    key: 'orderSn',
    width: 180
  },
  {
    title: '医药费',
    dataIndex: 'totalAmount',
    key: 'totalAmount',
    width: 180,
    customRender: ({ text }) => {
      return handlePrice(text)
    }
  },
  {
    title: '运费',
    dataIndex: 'freight',
    key: 'freight',
    width: 180,
    customRender: ({ text }) => {
      return handlePrice(text)
    }
  },
  // {
  //   title: '优惠券',
  //   dataIndex: 'couponPay',
  //   key: 'couponPay',
  //   width: 180,
  //   customRender: ({ text }) => {
  //     return handlePrice(text)
  //   }
  // },
  {
    title: '实付',
    dataIndex: 'realPay',
    key: 'realPay',
    width: 180,
    customRender: ({ text }) => {
      return handlePrice(text)
    }
  },
  {
    title: '订单状态',
    dataIndex: 'orderStatus',
    key: 'orderStatus',
    width: 180
  },
  {
    title: '创建时间',
    dataIndex: 'createdAt',
    key: 'createdAt',
    width: 180
  },
  {
    title: '支付时间',
    dataIndex: 'payTime',
    key: 'payTime',
    width: 180
  },
  {
    title: '物流单号',
    dataIndex: 'deliveryId',
    key: 'deliveryId',
    width: 180
  },
  {
    title: '发货时间',
    dataIndex: 'sendTime',
    key: 'sendTime',
    width: 180
  },
  // {
  //   title: '退款金额',
  //   dataIndex: 'salesPay',
  //   key: 'salesPay',
  //   width: 180
  // },
  // 退款金额改为“应退金额”和“实退金额”，若未退款，则展示“---”
  {
    title: '应退金额',
    dataIndex: 'shouldRefund',
    key: 'shouldRefund',
    width: 180,
    customRender: ({ text }) => {
      return handlePrice(text, false)
    }
  },
  {
    title: '实退金额',
    dataIndex: 'salesPay',
    key: 'salesPay',
    width: 180,
    customRender: ({ text }) => {
      return handlePrice(text, false)
    }
  },
  {
    title: '退款时间',
    dataIndex: 'refundAt',
    key: 'refundAt',
    width: 180
  },
  {
    title: '药房点评',
    dataIndex: 'reviewContent',
    key: 'reviewContent',
    width: 280,
    ellipsis: true,
    slots: {
      customRender: 'reviewContent'
    }
  }
]
// 售后信息（西药）
const columnSaleWestern = [
  {
    title: '售后单号',
    dataIndex: 'salesSn',
    key: 'salesSn',
    width: 180
  },
  {
    title: '订单号',
    dataIndex: 'orderSn',
    key: 'orderSn',
    width: 180
  },
  {
    title: 'sku编码',
    dataIndex: 'skuNumber',
    key: 'skuNumber',
    width: 180
  },
  {
    title: 'sku名称',
    dataIndex: 'skuName',
    key: 'skuName',
    width: 180
  },
  {
    title: '数量（盒）',
    dataIndex: 'quantity',
    key: 'quantity',
    width: 180
  },
  {
    title: '退货数量（盒）',
    dataIndex: 'returnQuantity',
    key: 'returnQuantity',
    width: 180
  },
  {
    title: '实付',
    dataIndex: 'realPay',
    key: 'realPay',
    width: 180,
    customRender: ({ text }) => {
      return handlePrice(text)
    }
  },
  {
    title: '应退金额',
    dataIndex: 'shouldRefund',
    key: 'shouldRefund',
    width: 180,
    customRender: ({ text }) => {
      return handlePrice(text, false)
    }
  },
  {
    title: '实退金额',
    dataIndex: 'returnPrice',
    key: 'returnPrice',
    width: 180,
    customRender: ({ text }) => {
      return handlePrice(text, false)
    }
  },
  {
    title: '实付运费',
    dataIndex: 'freight',
    key: 'freight',
    width: 180,
    customRender: ({ text }) => {
      return handlePrice(text)
    }
  },
  {
    title: '退款运费',
    dataIndex: 'refundFreight',
    key: 'refundFreight',
    width: 180,
    customRender: ({ text }) => {
      return handlePrice(text, false)
    }
  },
  {
    title: '退款原因',
    dataIndex: 'salesReason',
    key: 'salesReason',
    width: 180
  }
]
export { BASE_LABEL, columnHealth, getStatusImg, columnOrder, columnSaleWestern }
